module.exports = __webpack_public_path__ + "media/images/site/main_image1-cb75ae48831de569d393f6a91979939b.jpg";